<div mat-dialog-title class="popup-header">
    <div class="flexContent spacebetween align-center">
        <h2>Dodaj nieobecność</h2>
        <button mat-icon-button type="button" class="theme-button--primary" (click)="cancelButtonClick()">
            <mat-icon>close</mat-icon>
        </button>
    </div>
</div>
<mat-dialog-content class="mat-typography popup-content ">
    <form [formGroup]="addScheduleForm"
        class="flexContent flexColumn justify-stretch layout-py-10 gap-12">

        <mat-form-field>
            <mat-label>Początek - koniec</mat-label>
            <mat-date-range-input [rangePicker]="picker">
                <input matStartDate placeholder="Początek" formControlName="dateStart">
                <input matEndDate placeholder="Koniec" formControlName="dateEnd">
            </mat-date-range-input>
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Typ</mat-label>
            <mat-select formControlName="scheduleType">
                <mat-option *ngFor="let option of scheduleTypeOptionsList"
                    [value]="option.Id">{{option.Title}}</mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Status</mat-label>
            <mat-select formControlName="scheduleStatus">
                <mat-option *ngFor="let option of scheduleStatusOptionsList"
                    [value]="option.Id">{{option.Title}}</mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field>
            <textarea formControlName="description" matInput placeholder="Uwagi"></textarea>
        </mat-form-field>

    </form>
</mat-dialog-content>
<mat-dialog-actions align="end" class="popup-actions">
    <button type="button" mat-button class="theme-button--primary" (click)="cancelButtonClick()">
        <span class="action-button">
            Zamknij
        </span>
    </button>
    <button type="button" class="theme-button--green" [disabled]="!addScheduleForm.valid" mat-button
        (click)="confirmButtonClick()">
        <span class="action-button">
            Utwórz
        </span>
    </button>
</mat-dialog-actions>